import { Component, Input } from '@angular/core';
import { AnswerModel } from 'src/app/api/models';

@Component({
  selector: 'qa-free-text-answers-grid',
  standalone: true,
  templateUrl: './free-text-answers-grid.component.html',
  styleUrl: './free-text-answers-grid.component.scss',
  imports: [],
})
export class FreeTextAnswersGridComponent {
  @Input() answers: AnswerModel[] = [];
}
